import { fetchClient, isApiErrorV2 } from '@/util/fetchClient';

export type CheckEmailAvailabilityResponse = {
  available?: boolean;
  reason?: 'in_use' | 'pending_verification' | 'pending_invite' | 'reserved' | unknown;
  authProvider?: 'password' | 'google';
  maskedEmail?: string;
  error?: string;
};

export async function checkEmailAvailable(email: string): Promise<CheckEmailAvailabilityResponse> {
  try {
    const { data } = await fetchClient.POST('/v2/users/email/available', {
      body: { email },
    });

    return (data as any)?.data || (data as any) || {};
  } catch (error) {
    if (isApiErrorV2(error)) {
      return (error.body as any) || { available: false, error: 'Unknown error' };
    }

    throw error;
  }
}
